import { FC, memo, useCallback } from "react";

import Grid from "apps/website/components/layout/Grid/Grid";
import { AvailableTag } from "apps/website/components/base/List/List.map";

import { TTitleTag } from "../../base/Text/types";

import ImageTextListItemColumn, {
  IImageTextItem,
} from "./ImageTextListItem/ImageTextListItemColumn";
import { Columns } from "./ImageTextListItem/ImageTextListItemColumn.map";
import ImageTextListItemRow from "./ImageTextListItem/ImageTextListItemRow";

export type Flow = "column" | "row";

export interface IImageTextList {
  items: IImageTextItem[];
  itemTitleTag?: TTitleTag;
  listType?: AvailableTag;
  flow?: Flow;
  columns?: Columns;
  lazy?: boolean;
}

const ImageTextList: FC<IImageTextList> = ({
  items = [],
  itemTitleTag = "h3",
  listType = "ul",
  flow = "row",
  columns,
  lazy = true,
}) => {

  const makeListItem = useCallback((item: IImageTextItem, number: number, itemFlow: Flow): IImageTextItem => ({
    ...item,
    title: listType === "ol" ? `${number}. ${item.title}` : item.title,
    titleDisplay: listType === "ol" || itemFlow === "column" ? "title" : "subtitle",
  }), [ listType ]);

  return (
    <Grid tag={listType} component="ImageTextList">
      <>
        { flow === "row" && (
          <>
            { items.map((item, index) => (
              <ImageTextListItemColumn
                key={item.title}
                item={makeListItem(item, index + 1, "row")}
                itemTitleTag={itemTitleTag}
                columns={columns}
                lazy={lazy}
              />
            )) }
          </>
        ) }
        { flow === "column" && (
          <>
            { items.map((item, index) => (
              <ImageTextListItemRow
                key={item.title}
                item={makeListItem(item, index + 1, "column")}
                itemTitleTag={itemTitleTag}
                direction={index % 2 === 0 ? "default" : "reverse"}
                lazy={lazy}
              />
            )) }
          </>
        ) }
      </>
    </Grid>
  );
};

export default memo(ImageTextList);
